module.exports = __webpack_public_path__ + "static/media/pitch_logo.35fac512.png";